export default "__VITE_ASSET__DYe6xA7R__"